// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.requirements[data-v-e29ef056]{\r\n\twhite-space: pre-line;\r\n\tposition: relative;\r\n\toverflow: hidden;\n}\n.text[data-v-e29ef056] {\r\n\tpointer-events: none;\r\n\tposition: relative;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
